import React from "react";
import Card from "../components/card/Card";
import Collection from "../components/collection/Collection";
import GetApp from "../components/getapp/GetApp";
import Header from "../components/header/Header";
import PopularLocality from "../components/popularlocality/PopularLocality";

const Home = () => {
  return (
    <>
      <Header />
      <Card />
      <Collection />
      <PopularLocality />
      <GetApp />
    </>
  );
};

export default Home;
